import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';

const useUtilities = () => {
  const { roleId } = useParams();
  const [cookies] = useCookies();

  const isSolo = () => {
    return roleId === 'solo-instructor' || roleId === 'solo-client';
  };

  const isSoloInstructor = () => {
    return roleId === 'solo-instructor';
  };
  const isSoloClient = () => {
    return roleId === 'solo-client';
  };
  const isLoggedIn = () => {
    return !!cookies?.token;
  };

  return {
    isSolo,
    isSoloInstructor,
    isSoloClient,
    isLoggedIn,
  };
};

export default useUtilities;
